export default "__VITE_ASSET__Jmux9UmU__"